import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { textEllipsis } from 'utils/ellipsis';
import { Popup, Text } from './atoms';
import { PropertiesPopup } from 'atoms';

const template = styled.div`
  ${({ theme, displayState }) => css`
    display: flex;
    align-items: center;
    position: relative;
    color: ${theme?.colour?.secondary};
    font-size: 12px;
    line-height: 14px;
    margin-top: 8px;

    span {
      display: none;
    }

    &:hover {
      span {
        display: ${displayState?.showPopup ? 'unset' : ''};
      }
    }
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Text,
      name: 'Property',
      displayValue: ({ properties }) => properties.length > 1 ? textEllipsis(properties[0], 15) : properties[0] ?? '',
    },
    {
      component: Text,
      name: 'More',
      displayValue: ({ properties }) => `and ${properties.length - 1} other`,
      displayState: ({ properties }) => ({ underline: true, hidden: properties.length === 1 })
    },
    {
      component: PropertiesPopup,
      name: 'Popup',
      displayValue: ({ properties }) => properties.join(', ')
    }
  ],
})